/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-unused-vars */
/* eslint-disable import/order */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable comma-dangle */
/* eslint-disable operator-linebreak */
/* eslint-disable jsx-quotes */
/* eslint-disable react/jsx-filename-extension */
import './loginForm.css';

import {
  Alert,
  Box,
  Chip,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  MenuItem,
  Modal,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import {
  getAddressSearchResponse,
  getLeaseholderResponse,
  updateContactInfo,
} from '../../services/chatBotService';
import { getCookieValue, setCookie } from '../../util/cookies';
import { isEmpty, sortBy, startCase } from 'lodash';

import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import HomeIcon from '@mui/icons-material/Home';
import { IMaskInput } from 'react-imask';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';

const TextMaskCustom = React.forwardRef((props, ref) => {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="(000)000-0000"
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      autoComplete="off"
      validate={false}
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

TextMaskCustom.displayName = 'TextMaskCustom';

function LoginForm({
  setUnitCode,
  setLoginFormSubmitted,
  closeForm,
  openForm,
}) {
  const [addressOptions, setAddressOptions] = useState([]);
  const [addressSearchText, setAddressSearchText] = useState(null);
  const [addressResponse, setAddressResponse] = useState({});
  const [selectedAddress, setSelectedAddress] = useState({});
  const [neighborhood, setNeighborhood] = useState([]);
  const [leaseholder, setLeaseholder] = useState([]);
  const [unitOccupied, setUnitOccupied] = useState(true);
  const [isVacantUnit, setIsVacantUnit] = useState(false);
  const [isHHRUnit, setIsHHRUnit] = useState(false);
  const [tenantDetails, setTenantDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [addressLoading, setaddressLoading] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info',
  });
  const getAccessNotes = () => {
    const accessNotesObject = {
      createdBy: getCookieValue('username')?.replace(/^["']|["']$/g, ''),
      ...(!isEmpty(tenantDetails.alternativePhoneNumber)
        ? { ALT_PHONE: tenantDetails.alternativePhoneNumber }
        : {}),
      ...(!isEmpty(tenantDetails.alternativeEmail)
        ? { ALT_EMAIL: tenantDetails.alternativeEmail }
        : {}),
      ...(!isEmpty(tenantDetails.alternativePhoneNumberForText)
        ? { TEXT_MSG: tenantDetails.alternativePhoneNumberForText }
        : {}),
    };

    if (Object.keys(accessNotesObject).length === 0) return '';
    return Object.entries(accessNotesObject)
      ?.filter(([_, value]) => !isEmpty(value))
      .map(([key, value]) => `${startCase(key)}: ${value}`)
      .join('; ');
  };

  const getLeaseholderLabel = () => {
    if (loading) {
      return 'Loading lease holders';
    }
    if (!unitOccupied) {
      return 'Vacant Unit - No leaseholder';
    }
    return 'Lease holder name';
  };

  // Email validation function
  const isValidEmail = (email) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    return emailRegex.test(email);
  };

  const formik = useFormik({
    initialValues: {
      alternativeEmail: '',
      alternativePhoneNumber: '',
      alternativePhoneNumberForText: '',
      leaseHolderEmail: false,
      leaseHolderPhoneNumber: false,
      reuseLeaseholderCallback: false,
      reuseAlternatePhone: false,
      address: undefined,
      yardiUnitCode: '',
      neighborhood: '',
      project: '',
      leaseholder: undefined,
    },
    validate: (formData) => {
      const errors = {};

      // Check if unit is vacant
      const isVacant = !unitOccupied;

      // For vacant units, leaseholder and communication preferences are not required
      if (isVacant) {
        if (!formData.address || !formData.yardiUnitCode) {
          errors.name = 'Required';
        }
      } else if (
        (formData.leaseHolderEmail === false &&
          formData.alternativeEmail === '') ||
        (formData.leaseHolderPhoneNumber === false &&
          (formData.alternativePhoneNumber === '' ||
            formData.alternativePhoneNumberForText === '')) ||
        !formData.address ||
        !formData.yardiUnitCode ||
        !formData.leaseholder
      ) {
        // For occupied units, all fields including leaseholder are required
        errors.name = 'Required';
      }
      // Email format validation
      if (
        formData.alternativeEmail &&
        !isValidEmail(formData.alternativeEmail)
      ) {
        errors.alternativeEmail = 'Invalid email format';
      }

      // alternative phone number length validation
      if (
        formData.alternativePhoneNumber &&
        formData.alternativePhoneNumber.length !== 13
      ) {
        errors.alternativePhoneNumber = 'Phone number must be 10 digits';
      }

      // alternative phone number for text length validation
      if (
        formData.alternativePhoneNumberForText &&
        formData.alternativePhoneNumberForText.length !== 13
      ) {
        errors.alternativePhoneNumberForText =
          'Phone number for text must be 10 digits';
      }
      setIsSubmitDisabled(Object.keys(errors).length > 0);
      return errors;
    },
    onSubmit: (formData) => {
      try {
        setLoginFormSubmitted(true);

        const tenantDetailsWithAccessNotes = {
          ...tenantDetails,
          accessNotes: getAccessNotes(),
          isVacant: !unitOccupied,
        };

        sessionStorage.setItem(
          'tenantDetails',
          JSON.stringify(tenantDetailsWithAccessNotes)
        );

        // For vacant units, we may not have tenant details
        if (tenantDetails.tenantCode) {
          setCookie('tenant_code', tenantDetails.tenantCode, 1);
        }
        if (isVacantUnit) {
          setCookie('is_vacant', 'true', 1);
        }
        if (isHHRUnit) {
          setCookie('is_hhr', 'true', 1);
        }
        if (tenantDetails.tenantId) {
          setCookie('tenant_id', tenantDetails.tenantId, 1);
        }
        setCookie('neighborhood_code', tenantDetails.neighborhood, 1);

        // Close form for both occupied and vacant units
        closeForm(false);
      } catch (error) {
        console.log('Error while submitting :: ', error);
      }
    },
  });

  const resetAddressOptions = () => {
    setAddressOptions([]);
    setNeighborhood([]);
    setLeaseholder([]);
    setSelectedAddress([]);
    setAddressSearchText(null);
    setTenantDetails({});
    formik.resetForm();
  };

  const handleAddressOptionChange = (event, query) => {
    if (formik.values.address && query !== formik.values.address) {
      resetAddressOptions();
      setUnitOccupied(true);
    }

    if (query) {
      setAddressSearchText(query);
      if (query.length >= 2) {
        setaddressLoading(true);

        getAddressSearchResponse(query)
          .then((response) => {
            const keys = Object.keys(response);
            setAddressOptions(keys);
            setAddressResponse(response);
            if (Object.keys(response).length === 1) {
              const currentAddress = Object.keys(response)[0];
              setSelectedAddress(response[currentAddress]);
              setIsVacantUnit(
                Array.isArray(selectedAddress) &&
                  selectedAddress.some((unit) => unit.isVacant)
              );
              setIsHHRUnit(
                Array.isArray(selectedAddress) &&
                  selectedAddress.some((unit) => unit.dbType === 'HHR')
              );
              setUnitOccupied(!isVacantUnit);
              formik.setFieldValue('address', currentAddress);
              const neighborhoodOptions = response[currentAddress].map(
                (_address) => ({
                  neighbourhood: _address.neighborhood,
                  neighborhoodName: _address.neighborhoodName,
                })
              );
              setNeighborhood(sortBy(neighborhoodOptions, 'neighborhoodName'));
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setaddressLoading(false);
          });
      } else {
        resetAddressOptions();
        setUnitOccupied(true);
      }
    } else {
      resetAddressOptions();
    }
  };

  const handleSelectAddress = (event, address) => {
    if (address) {
      formik.handleChange(event);
      formik.setFieldValue('address', address);
      setSelectedAddress(addressResponse[address]);
      setIsVacantUnit(
        Array.isArray(selectedAddress) &&
          selectedAddress.some((unit) => unit.isVacant)
      );
      setIsHHRUnit(
        Array.isArray(selectedAddress) &&
          selectedAddress.some((unit) => unit.dbType === 'HHR')
      );
      if (isHHRUnit) {
        setCookie('is_hhr', 'true', 1);
      }
      setUnitOccupied(!isVacantUnit);
      setTenantDetails((prevState) => ({
        ...prevState,
        address,
        isHHRUnit,
      }));
      const neighborhoodOptions = addressResponse[address].map((_address) => ({
        neighbourhood: _address.neighborhood,
        neighborhoodName: _address.neighborhoodName,
      }));
      setNeighborhood(sortBy(neighborhoodOptions, 'neighborhoodName'));
      setAddressOptions([]);
    } else {
      setAddressOptions([]);
      formik.setFieldValue('address', '');
      setNeighborhood([]);
      formik.setFieldValue('neighborhood', '');
    }
  };

  const handleNeighborhoodSelect = (e, value) => {
    if (value) {
      const selectedNeighborhood = value;
      formik.handleChange(e);
      const currentAddress = selectedAddress.find(
        (address) =>
          address.neighborhoodName === selectedNeighborhood.neighborhoodName
      );
      console.log(currentAddress);
      formik.setValues({
        ...formik.values,
        neighborhood: selectedNeighborhood,
        yardiUnitCode: currentAddress.unitCode,
        project: currentAddress.project,
      });
      setUnitCode(currentAddress.unitCode);
      const isHhr = currentAddress.dbType === 'HHR';
      setIsHHRUnit(isHhr);
      setCookie('is_hhr', isHhr ? 'true' : 'false', 1);
      setCookie('neighborhood', currentAddress.neighborhood);
      setTenantDetails((prevState) => ({
        ...prevState,
        ...currentAddress,
      }));

      // Set unit occupied status based on isVacant field
      setUnitOccupied(!currentAddress.isVacant);

      setLoading(true);
      getLeaseholderResponse(currentAddress.unitCode)
        .then((leaseholderResponse) => {
          setLeaseholder(sortBy(leaseholderResponse?.data, 'first_name'));

          // If unit is vacant, set empty string for leaseholder (not required)
          if (currentAddress.isVacant) {
            formik.setFieldValue('leaseholder', '');
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  const handleReuseLeaseholderCallback = (e) => {
    const { checked } = e.target;
    if (checked) {
      // Set SMS field to leaseholder callback number
      formik.setFieldValue('alternativePhoneNumberForText', tenantDetails.requestorPhoneNumber || '');
      formik.setFieldValue('reuseLeaseholderCallback', true);
      formik.setFieldValue('reuseAlternatePhone', false);
    } else {
      // Clear SMS field when unchecked
      formik.setFieldValue('alternativePhoneNumberForText', '');
      formik.setFieldValue('reuseLeaseholderCallback', false);
    }
  };

  const handleReuseAlternatePhone = (e) => {
    const { checked } = e.target;
    if (checked) {
      // Set SMS field to alternate phone number
      formik.setFieldValue('alternativePhoneNumberForText', formik.values.alternativePhoneNumber);
      formik.setFieldValue('reuseAlternatePhone', true);
      formik.setFieldValue('reuseLeaseholderCallback', false);
    } else {
      // Clear SMS field when unchecked
      formik.setFieldValue('alternativePhoneNumberForText', '');
      formik.setFieldValue('reuseAlternatePhone', false);
    }
  };

  const handleLeaseholderCallbackChange = (e) => {
    const { checked } = e.target;
    formik.handleChange(e);

    // If unchecking leaseholder callback, also uncheck and clear the reuse checkbox
    if (!checked && formik.values.reuseLeaseholderCallback) {
      formik.setFieldValue('reuseLeaseholderCallback', false);
      formik.setFieldValue('alternativePhoneNumberForText', '');
    }
  };

  const handleAlternativePhoneChange = (e) => {
    formik.handleChange(e);

    // If clearing alternate phone, also uncheck and clear the reuse checkbox
    if (!e.target.value && formik.values.reuseAlternatePhone) {
      formik.setFieldValue('reuseAlternatePhone', false);
      formik.setFieldValue('alternativePhoneNumberForText', '');
    }
  };

  const handleLeaseholderSelect = (e, value) => {
    if (value) {
      const selectedLeaseholder = value;
      formik.handleChange(e);
      formik.setValues({
        ...formik.values,
        leaseholder: selectedLeaseholder,
        leaseHolderEmail: false,
        leaseHolderPhoneNumber: false,
        reuseLeaseholderCallback: false,
        reuseAlternatePhone: false,
        alternativePhoneNumber: '',
        alternativePhoneNumberForText: '',
        alternativeEmail: '',
      });

      const leaseholderDetails = leaseholder.find(
        (details) =>
          `${details.first_name} ${details.last_name}` ===
          `${selectedLeaseholder.first_name} ${selectedLeaseholder.last_name}`
      );

      if (leaseholderDetails) {
        setTenantDetails((prevState) => ({
          ...prevState,
          tenantCode: leaseholderDetails?.tenant_code,
          tenantId: leaseholderDetails?.tenant_id,
          requestorName: `${leaseholderDetails?.first_name} ${leaseholderDetails?.last_name}`,
          type: leaseholderDetails?.type,
          requestorPhoneNumber: leaseholderDetails?.phone_num,
          requestorEmail: leaseholderDetails?.email,
          unitOccupied:
            leaseholderDetails.is_vacant === 'Occupied' || isVacantUnit,
        }));
        setUnitOccupied(
          leaseholderDetails.is_vacant === 'Occupied' || isVacantUnit
        );
      }
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const syncContactInfoToYardi = (contactData) => {
    // Non-blocking API call to sync contact info to Yardi
    updateContactInfo(contactData)
      .then(() => {
        console.log('Contact info synced successfully to Yardi');
      })
      .catch((error) => {
        console.error('Failed to sync contact info to Yardi:', error);
        // Show toast notification on failure
        setSnackbar({
          open: true,
          message: 'Contact details cannot be synced to Yardi',
          severity: 'error',
        });
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const updatedTenantDetails = {
      ...tenantDetails,
      // if lease holder email is selected then update it in requestor email
      // else provider alternative email
      requestorEmail: formik.values.leaseHolderEmail
        ? formik.values.leaseholder.email
        : formik.values.alternativeEmail,

      alternativeEmail: formik.values.alternativeEmail,

      // if lease holder phone is selected then update it in requestor phone
      // else provider alternative phone
      requestorPhoneNumber: formik.values.leaseHolderPhoneNumber
        ? formik.values.leaseholder.phone_num
        : formik.values.alternativePhoneNumber,
      alternativePhoneNumber: formik.values.alternativePhoneNumber,

      alternativePhoneNumberForText:
        formik.values.alternativePhoneNumberForText,
    };

    setTenantDetails(updatedTenantDetails);

    // Check if contact information was entered manually
    const hasManualContactInfo =
      formik.values.alternativeEmail ||
      formik.values.alternativePhoneNumber ||
      formik.values.alternativePhoneNumberForText;
    // If contact info was entered manually, sync to Yardi (non-blocking)
    if (tenantDetails.type === 'Primary Leaseholder') {
      if (hasManualContactInfo && tenantDetails.tenantCode) {
        console.log('Contact Info Testing: Inside the condition');
        const contactPayload = {
          tenantId: tenantDetails.tenantCode,
          propertyCode: tenantDetails.neighborhood,
          unitCode: tenantDetails.unitCode,
        };

        // Add email if provided
        if (formik.values.alternativeEmail) {
          contactPayload.email = formik.values.alternativeEmail;
        }

        // Add home phone if provided
        if (formik.values.alternativePhoneNumber) {
          contactPayload.homePhone = formik.values.alternativePhoneNumber;
        }

        // Add other phone (for SMS) if provided
        if (formik.values.alternativePhoneNumberForText) {
          contactPayload.otherPhone = formik.values.alternativePhoneNumberForText;
        }

        // Make non-blocking API call
        syncContactInfoToYardi(contactPayload);
      }
    }
    formik.handleSubmit();
  };

  const getNoOptionsText = () => {
    if (addressLoading) return 'Loading addresses...';
    if (addressSearchText) return 'No results found. Please refine your search.';
    return 'Type at least 3 characters to see available options.';
  };

  // Trigger validation when unitOccupied state changes
  useEffect(() => {
    // Only trigger validation if address and unit code are filled
    if (formik.values.address && formik.values.yardiUnitCode) {
      formik.validateForm();
    }
  }, [unitOccupied]);

  return (
    <>
      <Modal
        disableEnforceFocus
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        open={openForm}
      >
        <div className="submit-popup-container">
          <form onSubmit={handleSubmit}>
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '60%',
                height: '90%',
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 24,
                display: 'flex',
                flexDirection: 'column',

                minWidth: '500px',
                overflow: 'scroll',
              }}
            >
              <Box sx={{ overflow: 'auto', flexGrow: 1, p: 4 }}>
                <Box marginBottom={3}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    marginBottom={1}
                  >
                    <Typography
                      id="modal-modal-title"
                      color="#52663c"
                      fontSize={24}
                    >
                      Resident Unit Identification
                    </Typography>
                    {Array.isArray(selectedAddress) &&
                      selectedAddress.some((unit) => unit.isVacant) && (
                        <Chip
                          icon={<HomeIcon />}
                          label="Vacant Unit"
                          color="warning"
                          variant="outlined"
                          size="small"
                          sx={{
                            backgroundColor: '#fff3e0',
                            borderColor: '#ff9800',
                            color: '#ff9800',
                            '& .MuiChip-icon': {
                              color: '#ff9800',
                            },
                          }}
                        />
                    )}
                  </Box>
                  <Box
                    display="flex"
                    flexDirection="column"
                    marginBottom={2}
                    gap={2}
                  >
                    <Autocomplete
                      fullWidth
                      autoFocus
                      autoHighlight
                      options={addressOptions}
                      id="address"
                      loading={loading}
                      onInputChange={handleAddressOptionChange}
                      onChange={handleSelectAddress}
                      noOptionsText={getNoOptionsText()}
                      renderOption={(props, option) => {
                        const addressData = addressResponse[option];
                        const hasVacantUnit =
                          addressData &&
                          addressData.some((unit) => unit.isVacant);
                        return (
                          <li
                            {...props}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                            }}
                          >
                            <span>{option}</span>
                            {hasVacantUnit && (
                              <Tooltip title="Vacant" arrow>
                                <HomeIcon
                                  sx={{
                                    fontSize: 16,
                                    color: '#ff9800',
                                    marginLeft: 1,
                                  }}
                                />
                              </Tooltip>
                            )}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          required
                          fullWidth
                          helperText="Example: 123 Apple Court"
                          {...params}
                          label="Address"
                          variant="standard"
                          color="success"
                          autoFocus
                          autoComplete="off"
                        />
                      )}
                    />
                    <TextField
                      id="neighborhood"
                      fullWidth
                      select
                      required
                      value={formik.values.neighborhood}
                      onChange={(e) =>
                        handleNeighborhoodSelect(e, e.target.value)
                      }
                      variant="standard"
                      color="success"
                      label="Neighborhood"
                      disabled={Object.keys(selectedAddress).length === 0}
                    >
                      {neighborhood.map((option) => (
                        <MenuItem key={option.neighborhoodName} value={option}>
                          {option.neighborhoodName}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField
                      id="unit-code"
                      label="Yardi unit code"
                      variant="standard"
                      required
                      disabled
                      fullWidth
                      value={formik.values.yardiUnitCode}
                    />
                    <TextField
                      id="project"
                      label="Project"
                      variant="standard"
                      required
                      disabled
                      fullWidth
                      value={formik.values.project}
                    />
                    <TextField
                      id="leaseholder"
                      fullWidth
                      select={unitOccupied}
                      color="success"
                      required={unitOccupied}
                      value={formik.values.leaseholder}
                      onChange={(e) =>
                        handleLeaseholderSelect(e, e.target.value)
                      }
                      variant="standard"
                      label={getLeaseholderLabel()}
                      disabled={
                        !unitOccupied ||
                        (formik.values.yardiUnitCode === '' &&
                          leaseholder.length === 0) ||
                        isVacantUnit ||
                        loading
                      }
                      helperText={
                        !unitOccupied
                          ? 'Leaseholder not required for vacant units'
                          : ''
                      }
                    >
                      {leaseholder?.map((option) => (
                        <MenuItem key={option.first_name} value={option}>
                          {`${option.first_name} ${option.last_name} ( ${option.type} )`}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Box>
                  <Box
                    display="flex"
                    justifyContent="flex-start"
                    alignItems="center"
                  >
                    <Typography
                      id="modal-modal-title"
                      color="#52663c"
                      fontSize={24}
                    >
                      Followup Communication Preferences
                    </Typography>
                  </Box>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-start"
                    gap={1}
                  >
                    <FormGroup sx={{ width: '100%' }}>
                      <Grid container>
                        <Grid item xs={12} sm={6}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                color="success"
                                name="leaseHolderEmail"
                                checked={formik.values.leaseHolderEmail}
                                onChange={formik.handleChange}
                                disabled={
                                  !unitOccupied ||
                                  isEmpty(formik.values.leaseholder) ||
                                  loading ||
                                  isEmpty(tenantDetails) ||
                                  (tenantDetails.tenantCode &&
                                    isEmpty(tenantDetails.requestorEmail))
                                }
                              />
                            }
                            label="E-Mail Leaseholder"
                          />

                          {unitOccupied &&
                            formik.values.yardiUnitCode !== '' &&
                            leaseholder.length !== 0 && (
                              <FormHelperText
                                error={
                                  tenantDetails.tenantCode &&
                                  isEmpty(tenantDetails.requestorEmail)
                                }
                              >
                                {tenantDetails.tenantCode &&
                                isEmpty(tenantDetails.requestorEmail)
                                  ? 'No E-Mail on file'
                                  : tenantDetails.requestorEmail}
                              </FormHelperText>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="leaseHolderPhoneNumber"
                                color="success"
                                checked={formik.values.leaseHolderPhoneNumber}
                                onChange={handleLeaseholderCallbackChange}
                                disabled={
                                  !unitOccupied ||
                                  isEmpty(formik.values.leaseholder) ||
                                  loading ||
                                  isEmpty(tenantDetails) ||
                                  (tenantDetails.tenantCode &&
                                    isEmpty(tenantDetails.requestorPhoneNumber))
                                }
                              />
                            }
                            label="Leaseholder Callback"
                          />
                          {unitOccupied &&
                            formik.values.yardiUnitCode !== '' &&
                            leaseholder.length !== 0 && (
                              <FormHelperText
                                error={
                                  tenantDetails.tenantCode &&
                                  isEmpty(tenantDetails.requestorPhoneNumber)
                                }
                              >
                                {tenantDetails.tenantCode &&
                                isEmpty(tenantDetails.requestorPhoneNumber)
                                  ? 'No phone on file'
                                  : tenantDetails.requestorPhoneNumber}
                              </FormHelperText>
                          )}
                        </Grid>
                      </Grid>
                    </FormGroup>
                    <TextField
                      id="alternative-email"
                      color="success"
                      label={
                        (() => {
                          const isTenant = tenantDetails.tenantCode && tenantDetails.type === 'Tenant';
                          const noEmail = isEmpty(tenantDetails.requestorEmail);
                          if (isTenant) {
                            return noEmail
                              ? 'No EMail on File, please provide an alternate (This will update contact information in Yardi)'
                              : 'Please provide an alternate';
                          }
                          return noEmail
                            ? 'No EMail on File, please provide an alternate (This will update contact information in Yardi)'
                            : 'Update Primary EMail (This will update contact information in Yardi)';
                        })()
                      }
                      variant="standard"
                      fullWidth
                      name="alternativeEmail"
                      value={formik.values.alternativeEmail}
                      onChange={formik.handleChange}
                      required={!formik.values.leaseHolderEmail}
                      disabled={
                        !unitOccupied || isEmpty(formik.values.leaseholder)
                      }
                      helperText={
                        formik.touched.alternativeEmail &&
                        formik.errors.alternativeEmail
                      }
                      error={
                        formik.touched.alternativeEmail &&
                        Boolean(formik.errors.alternativeEmail)
                      }
                      onBlur={formik.handleBlur}
                    />
                    <TextField
                      id="alternative-phone-number"
                      color="success"
                      label={
                        (() => {
                          const isTenant = tenantDetails.tenantCode && tenantDetails.type === 'Tenant';
                          const noPhone = isEmpty(tenantDetails.requestorPhoneNumber);
                          if (isTenant) {
                            return noPhone
                              ? 'No Phone on File, please provide an alternate (This will update contact information in Yardi)'
                              : 'Please provide an alternate';
                          }
                          return noPhone
                            ? 'No Phone on File, please provide an alternate (This will update contact information in Yardi)'
                            : 'Update Primary Phone Number (This will update contact information in Yardi)';
                        })()
                      }
                      variant="standard"
                      fullWidth
                      name="alternativePhoneNumber"
                      onChange={handleAlternativePhoneChange}
                      value={formik.values.alternativePhoneNumber}
                      required={!formik.values.leaseHolderPhoneNumber}
                      InputProps={{
                        inputComponent: TextMaskCustom,
                      }}
                      disabled={
                        !unitOccupied || isEmpty(formik.values.leaseholder)
                      }
                      error={
                        formik.touched.alternativePhoneNumber &&
                        Boolean(formik.errors.alternativePhoneNumber)
                      }
                      helperText={
                        formik.touched.alternativePhoneNumber &&
                        formik.errors.alternativePhoneNumber
                          ? formik.errors.alternativePhoneNumber
                          : 'Example: (555)867-5309'
                      }
                      onBlur={formik.handleBlur}
                    />
                    <TextField
                      id="alternative-phone-number-for-text-messages"
                      color="success"
                      label={
                        tenantDetails.tenantCode &&
                        isEmpty(tenantDetails.requestorPhoneNumber)
                          ? 'No phone on file, please provide an alternate for SMS Updates'
                          : 'Please provide an alternate phone for SMS Updates'
                      }
                      variant="standard"
                      fullWidth
                      name="alternativePhoneNumberForText"
                      value={formik.values.alternativePhoneNumberForText}
                      onChange={formik.handleChange}
                      required={
                        !formik.values.leaseHolderPhoneNumber &&
                        !formik.values.reuseLeaseholderCallback &&
                        !formik.values.reuseAlternatePhone
                      }
                      InputProps={{
                        inputComponent: TextMaskCustom,
                      }}
                      disabled={
                        !unitOccupied ||
                        isEmpty(formik.values.leaseholder) ||
                        formik.values.reuseLeaseholderCallback ||
                        formik.values.reuseAlternatePhone
                      }
                      error={
                        formik.touched.alternativePhoneNumberForText &&
                        Boolean(formik.errors.alternativePhoneNumberForText)
                      }
                      helperText={
                        formik.touched.alternativePhoneNumberForText &&
                        formik.errors.alternativePhoneNumberForText
                          ? formik.errors.alternativePhoneNumberForText
                          : 'Example: (555)867-5309'
                      }
                      onBlur={formik.handleBlur}
                    />
                    <FormGroup sx={{ width: '100%' }}>
                      <Grid container>
                        <Grid item xs={12} sm={6}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                color="success"
                                name="reuseLeaseholderCallback"
                                checked={formik.values.reuseLeaseholderCallback}
                                onChange={handleReuseLeaseholderCallback}
                                disabled={
                                  !unitOccupied ||
                                  isEmpty(formik.values.leaseholder) ||
                                  loading ||
                                  !tenantDetails.requestorPhoneNumber ||
                                  !formik.values.leaseHolderPhoneNumber ||
                                  formik.values.reuseAlternatePhone
                                }
                              />
                            }
                            label="Use Callback Number"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                color="success"
                                name="reuseAlternatePhone"
                                checked={formik.values.reuseAlternatePhone}
                                onChange={handleReuseAlternatePhone}
                                disabled={
                                  !unitOccupied ||
                                  isEmpty(formik.values.leaseholder) ||
                                  loading ||
                                  isEmpty(formik.values.alternativePhoneNumber) ||
                                  formik.values.alternativePhoneNumber.length !== 13 ||
                                  formik.values.reuseLeaseholderCallback
                                }
                              />
                            }
                            label="Use Updated Primary Phone Number"
                          />
                        </Grid>
                      </Grid>
                    </FormGroup>
                  </Box>
                </Box>
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                p={2}
                sx={{ borderTop: '1px solid #e0e0e0' }}
              >
                <Button
                  variant="contained"
                  type="submit"
                  color="success"
                  disabled={isSubmitDisabled}
                  sx={{ borderRadius: 2, textTransform: 'none' }}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          </form>
        </div>
      </Modal>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}

LoginForm.propTypes = {
  setUnitCode: PropTypes.func.isRequired,
  setLoginFormSubmitted: PropTypes.func.isRequired,
  closeForm: PropTypes.func.isRequired,
  openForm: PropTypes.bool.isRequired,
};

export default LoginForm;
